// Hindi Vowels (Swaras)
export const vowels = [
  { letter: 'अ', roman: 'a', ipa: 'ə' },
  { letter: 'आ', roman: 'aa', ipa: 'aː' },
  { letter: 'इ', roman: 'i', ipa: 'ɪ' },
  { letter: 'ई', roman: 'ee', ipa: 'iː' },
  { letter: 'उ', roman: 'u', ipa: 'ʊ' },
  { letter: 'ऊ', roman: 'oo', ipa: 'uː' },
  { letter: 'ऋ', roman: 'ri', ipa: 'rɪ' },
  { letter: 'ए', roman: 'e', ipa: 'eː' },
  { letter: 'ऐ', roman: 'ai', ipa: 'æ' },
  { letter: 'ओ', roman: 'o', ipa: 'oː' },
  { letter: 'औ', roman: 'au', ipa: 'ɔː' },
  { letter: 'अं', roman: 'an', ipa: 'ən' },
  { letter: 'अः', roman: 'ah', ipa: 'əh' },
];

// Hindi Consonants (Vyanjanas)
export const consonants = [
  { letter: 'क', roman: 'ka', ipa: 'k' },
  { letter: 'ख', roman: 'kha', ipa: 'kh' },
  { letter: 'ग', roman: 'ga', ipa: 'ɡ' },
  { letter: 'घ', roman: 'gha', ipa: 'ɡh' },
  { letter: 'ङ', roman: 'nga', ipa: 'ŋ' },
  { letter: 'च', roman: 'cha', ipa: 'tʃ' },
  { letter: 'छ', roman: 'chha', ipa: 'tʃh' },
  { letter: 'ज', roman: 'ja', ipa: 'dʒ' },
  { letter: 'झ', roman: 'jha', ipa: 'dʒh' },
  { letter: 'ञ', roman: 'nya', ipa: 'ɲ' },
  { letter: 'ट', roman: 'ta', ipa: 'ʈ' },
  { letter: 'ठ', roman: 'tha', ipa: 'ʈh' },
  { letter: 'ड', roman: 'da', ipa: 'ɖ' },
  { letter: 'ढ', roman: 'dha', ipa: 'ɖh' },
  { letter: 'ण', roman: 'na', ipa: 'ɳ' },
  { letter: 'त', roman: 'ta', ipa: 't' },
  { letter: 'थ', roman: 'tha', ipa: 'th' },
  { letter: 'द', roman: 'da', ipa: 'd' },
  { letter: 'ध', roman: 'dha', ipa: 'dh' },
  { letter: 'न', roman: 'na', ipa: 'n' },
  { letter: 'प', roman: 'pa', ipa: 'p' },
  { letter: 'फ', roman: 'pha', ipa: 'ph' },
  { letter: 'ब', roman: 'ba', ipa: 'b' },
  { letter: 'भ', roman: 'bha', ipa: 'bh' },
  { letter: 'म', roman: 'ma', ipa: 'm' },
  { letter: 'य', roman: 'ya', ipa: 'j' },
  { letter: 'र', roman: 'ra', ipa: 'r' },
  { letter: 'ल', roman: 'la', ipa: 'l' },
  { letter: 'व', roman: 'va', ipa: 'ʋ' },
  { letter: 'श', roman: 'sha', ipa: 'ʃ' },
  { letter: 'ष', roman: 'sha', ipa: 'ʂ' },
  { letter: 'स', roman: 'sa', ipa: 's' },
  { letter: 'ह', roman: 'ha', ipa: 'h' },
  { letter: 'क्ष', roman: 'ksha', ipa: 'kʂ' },
  { letter: 'त्र', roman: 'tra', ipa: 'tr' },
  { letter: 'ज्ञ', roman: 'gya', ipa: 'dʒɲ' },
];

// Sample texts for OCR demo
export const sampleTexts = [
  'आज मौसम बहुत अच्छा है।',
  'भारत एक महान देश है।',
  'मुझे हिंदी पढ़ना और लिखना पसंद है।',
  'रसोई में आज स्वादिष्ट भोजन बन रहा है।',
  'हम सुबह पार्क में जाते हैं।',
];

// Floating alphabets for landing
export const floatingAlphas = ['अ','आ','इ','ई','उ','ऊ','ए','ओ','क','ख','ग','घ','च','ज','त','न','म','य','र','ल','व','स','ह'];
